import { createSelector } from 'reselect';
import Immutable from 'immutable';
import {
  selectCurrentCoursePath,
  currentCourseSelector,
} from '../Courses/selectors';

const defaultCertification = Immutable.fromJS({
  type: '',
  code: '',
  data: {},
  isProcessing: false,
});

export const selectCertification = (state) => state.Certification;

export const selectCurrentCourseCertification = createSelector(
  selectCertification,
  selectCurrentCoursePath,
  (certification, coursePath) => {
    if (coursePath) {
      return (
        certification.getIn(['byCoursePath', coursePath]) ||
        defaultCertification
      );
    } else {
      return null;
    }
  }
);

export const makeCertificationSelectorByCoursePath = (coursePath) =>
  createSelector([selectCertification], (certification) => {
    return certification.getIn(['byCoursePath', coursePath], Immutable.Map());
  });

export const selectCurrentCourseHasCertification = createSelector(
  [currentCourseSelector],
  (course) => {
    if (course) {
      const certification = course.get('certification');
      return certification && certification.get('type') !== 'no_certificate';
    } else {
      return false;
    }
  }
);
